export const DENOMINATIONS = [
  { value: 100000, id: 'one-thousand-dollar', short: '$1,000 note', name: '$1,000 gold-certificate game note', kind: 'note', views: 4 },
  { value: 50000, id: 'five-hundred-dollar', short: '$500 note', name: '$500 treasury game note', kind: 'note', views: 4 },
  { value: 10000, id: 'one-hundred-dollar', short: '$100 note', name: '$100 United States game note', kind: 'note', views: 4 },
  { value: 5000, id: 'fifty-dollar', short: '$50 note', name: '$50 gold-certificate game note', kind: 'note', views: 4 },
  { value: 2000, id: 'twenty-dollar', short: '$20 note', name: '$20 gold-certificate game note', kind: 'note', views: 4 },
  { value: 2000, id: 'double-eagle', short: '$20 gold', name: '$20 Liberty Head Double Eagle', kind: 'coin', views: 8 },
  { value: 1000, id: 'ten-dollar', short: '$10 note', name: '$10 United States game note', kind: 'note', views: 4 },
  { value: 500, id: 'five-dollar', short: '$5 note', name: '$5 United States game note', kind: 'note', views: 4 },
  { value: 100, id: 'one-dollar', short: '$1 note', name: '$1 silver-certificate game note', kind: 'note', views: 4 },
  { value: 100, id: 'morgan-dollar', short: '$1 silver', name: 'Morgan silver dollar', kind: 'coin', views: 8 },
  { value: 50, id: 'seated-half', short: '50¢ half', name: 'Liberty Seated half dollar', kind: 'coin', views: 8 },
  { value: 25, id: 'seated-quarter', short: '25¢ quarter', name: 'Liberty Seated quarter', kind: 'coin', views: 8 },
  { value: 10, id: 'seated-dime', short: '10¢ dime', name: 'Liberty Seated dime', kind: 'coin', views: 8 },
  { value: 1, id: 'indian-cent', short: '1¢ cent', name: 'Indian Head cent', kind: 'coin', views: 8 }
];

export const TABLE_MODES = {
  frontier: {
    id: 'frontier', label: 'Frontier stakes', buyIn: 2286, ante: 25, preDrawBet: 50, postDrawBet: 100,
    hardTimesBalance: 500, extremePot: Infinity
  },
  baron: {
    id: 'baron', label: 'Railroad Baron stakes', buyIn: 228600, ante: 2500, preDrawBet: 5000, postDrawBet: 10000,
    hardTimesBalance: 50000, extremePot: 100000
  }
};

export const RAILROAD_UNLOCK = TABLE_MODES.baron.buyIn;
export const DEFAULT_COIN_ORDER = DENOMINATIONS.map(piece => piece.id);

const profile = (id, label, description, seedOrder, fillOrder) => ({ id, label, description, seedOrder, fillOrder });

export const CURRENCY_PROFILES = {
  balanced: profile(
    'balanced', 'Balanced purse', 'Paper beneath, gold and silver above',
    ['one-thousand-dollar', 'five-hundred-dollar', 'one-hundred-dollar', 'fifty-dollar', 'double-eagle', 'ten-dollar', 'five-dollar', 'one-dollar', 'morgan-dollar', 'seated-half', 'seated-quarter', 'seated-dime', 'indian-cent'],
    ['one-thousand-dollar', 'five-hundred-dollar', 'one-hundred-dollar', 'fifty-dollar', 'twenty-dollar', 'double-eagle', 'ten-dollar', 'five-dollar', 'one-dollar', 'morgan-dollar', 'seated-half', 'seated-quarter', 'seated-dime', 'indian-cent']
  ),
  paper: profile(
    'paper', 'Paper-forward', 'More notes, with coin for exact change',
    ['one-thousand-dollar', 'five-hundred-dollar', 'one-hundred-dollar', 'fifty-dollar', 'twenty-dollar', 'ten-dollar', 'five-dollar', 'one-dollar', 'seated-half', 'seated-quarter', 'seated-dime', 'indian-cent'],
    ['one-thousand-dollar', 'five-hundred-dollar', 'one-hundred-dollar', 'fifty-dollar', 'twenty-dollar', 'ten-dollar', 'five-dollar', 'one-dollar', 'morgan-dollar', 'seated-half', 'seated-quarter', 'seated-dime', 'indian-cent']
  ),
  gold: profile(
    'gold', 'Gold-forward', 'Double Eagles over a practical note reserve',
    ['one-thousand-dollar', 'five-hundred-dollar', 'one-hundred-dollar', 'fifty-dollar', 'double-eagle', 'ten-dollar', 'five-dollar', 'one-dollar', 'morgan-dollar', 'seated-half', 'seated-quarter', 'seated-dime', 'indian-cent'],
    ['double-eagle', 'one-thousand-dollar', 'five-hundred-dollar', 'one-hundred-dollar', 'fifty-dollar', 'twenty-dollar', 'ten-dollar', 'five-dollar', 'one-dollar', 'morgan-dollar', 'seated-half', 'seated-quarter', 'seated-dime', 'indian-cent']
  ),
  silver: profile(
    'silver', 'Silver-forward', 'Morgan dollars and seated silver over notes',
    ['one-thousand-dollar', 'five-hundred-dollar', 'one-hundred-dollar', 'fifty-dollar', 'twenty-dollar', 'ten-dollar', 'five-dollar', 'one-dollar', 'morgan-dollar', 'seated-half', 'seated-quarter', 'seated-dime', 'indian-cent'],
    ['morgan-dollar', 'seated-half', 'seated-quarter', 'seated-dime', 'one-thousand-dollar', 'five-hundred-dollar', 'one-hundred-dollar', 'fifty-dollar', 'twenty-dollar', 'double-eagle', 'ten-dollar', 'five-dollar', 'one-dollar', 'indian-cent']
  )
};

const byId = Object.fromEntries(DENOMINATIONS.map(piece => [piece.id, piece]));

export function normalizeCoinOrder(order = DEFAULT_COIN_ORDER) {
  const known = new Set(DEFAULT_COIN_ORDER);
  const valid = [...new Set(order || [])].filter(id => known.has(id));
  return [...valid, ...DEFAULT_COIN_ORDER.filter(id => !valid.includes(id))];
}

export function preferCoin(order, id) {
  return normalizeCoinOrder([id, ...(order || []).filter(item => item !== id)]);
}

export function inventoryValue(inventory = {}) {
  return DENOMINATIONS.reduce((sum, piece) => sum + piece.value * Math.max(0, Math.floor(inventory[piece.id] || 0)), 0);
}

export function addCurrency(left = {}, right = {}) {
  return Object.fromEntries(DENOMINATIONS.map(piece => [piece.id, (left[piece.id] || 0) + (right[piece.id] || 0)]));
}

export function allocateCurrency(value, profileId = 'balanced') {
  let remaining = Math.max(0, Math.round(value));
  const selected = CURRENCY_PROFILES[profileId] || CURRENCY_PROFILES.balanced;
  const counts = Object.fromEntries(DENOMINATIONS.map(piece => [piece.id, 0]));

  // Seed one affordable piece from several useful denominations to keep physical piles mixed.
  for (const id of selected.seedOrder) {
    const piece = byId[id];
    if (piece && remaining >= piece.value) {
      counts[id] += 1;
      remaining -= piece.value;
    }
  }
  // Finish exactly according to the selected bias. The cent guarantees no remainder.
  for (const id of selected.fillOrder) {
    const piece = byId[id];
    if (!piece) continue;
    const count = Math.floor(remaining / piece.value);
    counts[id] += count;
    remaining -= count * piece.value;
  }
  if (remaining !== 0) throw new Error(`Currency allocation left ${remaining} cents`);
  return counts;
}

export function reallocateCurrency(inventory, profileId = 'balanced') {
  return allocateCurrency(inventoryValue(inventory), profileId);
}

export function withdrawCurrency(inventory, amount, profileId = 'balanced') {
  const total = inventoryValue(inventory);
  const paid = Math.min(total, Math.max(0, Math.round(amount)));
  return {
    paid,
    tender: allocateCurrency(paid, profileId),
    remaining: allocateCurrency(total - paid, profileId)
  };
}

export function decomposeCurrency(value, order = DEFAULT_COIN_ORDER) {
  let remaining = Math.max(0, Math.round(value));
  const counts = Object.fromEntries(DENOMINATIONS.map(piece => [piece.id, 0]));
  for (const id of normalizeCoinOrder(order)) {
    const piece = byId[id];
    const count = Math.floor(remaining / piece.value);
    counts[id] += count;
    remaining -= count * piece.value;
  }
  return counts;
}

export function piecesFromInventory(inventory = {}, limit = 10, kind = null) {
  const pieces = [];
  const pool = DENOMINATIONS.filter(piece => !kind || piece.kind === kind);
  let layer = 0;
  while (pieces.length < limit) {
    let added = false;
    for (const piece of pool) {
      if ((inventory[piece.id] || 0) > layer) {
        pieces.push(piece);
        added = true;
        if (pieces.length >= limit) break;
      }
    }
    if (!added) break;
    layer += 1;
  }
  return pieces;
}

export function coinPieces(value, order = DEFAULT_COIN_ORDER, limit = 10) {
  return piecesFromInventory(decomposeCurrency(value, order), limit);
}
